import React from 'react';
import PropTypes from 'prop-types';
import { Link, Icon } from '@paypalcorp/pp-react';
import { grey600 } from '@paypalcorp/pp-react-colors';

function SocialShareMessenger({
  url,
  handleSocialLinkClick,
  linkTitle,
  color = grey600,
}) {
  return (
    <Link
      href={url}
      target="popup"
      onClick={() => handleSocialLinkClick(url, 'messenger')}
      title={linkTitle}
      style={{ color }}
      data-testid="social-share-messenger"
    >
      <Icon name="share-messenger" size="lg" />
    </Link>
  );
}

SocialShareMessenger.propTypes = {
  url: PropTypes.string,
  handleSocialLinkClick: PropTypes.func,
  linkTitle: PropTypes.string,
  color: PropTypes.string,
};

export default SocialShareMessenger;
